module.exports = __webpack_public_path__ + "static/vmware-6966e7ce4d4c13ee2db9b6e1549ff892.png";